module.exports = new __parcel__URL__("62354_sq.2a1dd98e.jpg").toString();